import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CrossReference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.25 18H11.25V19.5H8.25V18ZM3.75 18H6.75V19.5H3.75V18ZM17.25 18H20.25V19.5H17.25V18ZM12.75 18H15.75V19.5H12.75V18ZM6.74995 16.5C7.4518 15.5481 8.56736 14.9904 9.74995 15H14.25C15.4243 15.0246 16.5256 15.5753 17.25 16.5H18.975C18.1277 14.6572 16.2781 13.4828 14.25 13.5H9.74995C7.72177 13.4828 5.8722 14.6572 5.02495 16.5H6.74995ZM18 21H19.5V22.5H18V21ZM4.5 21H6V22.5H4.5V21ZM12 12C9.1005 12 6.75 9.6495 6.75 6.75C6.75 3.85051 9.1005 1.5 12 1.5C14.8995 1.5 17.25 3.85051 17.25 6.75C17.25 9.6495 14.8995 12 12 12ZM12 3C9.92893 3 8.25 4.67893 8.25 6.75C8.25 8.82107 9.92893 10.5 12 10.5C14.0711 10.5 15.75 8.82107 15.75 6.75C15.75 4.67893 14.0711 3 12 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CrossReference.vue"]]);
